/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";

import type { FcWithoutChildren } from "types/fcWithoutChildren";

const EMPTY_ARRAY_COUNT = 0;

type Props = {
  // 型定義上は string[] | undefined だが、ローカルで null パターンを確認したため null | undefined としてる
  tagList: string[] | undefined | null;
};

export const TagList: FcWithoutChildren<Props> = (props) => {
  const { tagList } = props;

  if (!Array.isArray(tagList) || tagList.length === EMPTY_ARRAY_COUNT)
    return null;

  return (
    <ul css={rootStyle}>
      {Array.from(new Set(tagList)).map((tag) => (
        <li key={tag} css={tagItemStyle}>
          {tag}
        </li>
      ))}
    </ul>
  );
};

const rootStyle = css`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const tagItemStyle = css`
  background-color: #a3a3a3;
  border-radius: 16px;
  color: #fff;
  display: inline-block;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  padding-inline: 12px;
`;
